enum TagId {
  PriceDrop = 103,
  GreatDeal = 104,
  EVCredit = 116,
  RecentlyAdded = 121
}

export default TagId;
